

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import { loadTurnstileScript, setTurnstileToken } from '@/utils/turnstile';

@Component
export default class Turnstile extends Vue {
    widgetId: string | null = null;

    @Ref('turnstile-dialog')
    dialog!: HTMLDialogElement;

    @Ref('turnstile-widget')
    widgetContainer!: HTMLElement;

    @Prop({ required: true })
    siteKey!: string | null;

    @Prop({ required: true })
    shopId!: string;

    async mounted() {
        if (!this.siteKey) {
            return;
        }

        if (!(await this.shouldShowTurnstile())) {
            return;
        }

        try {
            await loadTurnstileScript();
        } catch (e) {
            console.error('Failed to load Turnstile script', e);
            return;
        }

        if (!window.turnstile) {
            return;
        }

        this.dialog.showModal();

        this.$nextTick(() => {
            this.widgetId = window.turnstile.render(this.widgetContainer, {
                sitekey: this.siteKey!,
                callback: (token: string) => {
                    setTurnstileToken(token);
                    this.$emit('verified', token);

                    if (this.dialog.open) {
                        this.dialog.close();
                    }
                },
                'error-callback': () => {
                    this.$emit('error');
                },
                'expired-callback': () => {
                    setTurnstileToken(null);
                    this.$emit('expired');
                },
            });
        });
    }

    async shouldShowTurnstile(): Promise<boolean> {
        if (!this.shopId) {
            return false;
        }

        try {
            const response = await fetch(
                `https://ev3b.s3.eu-west-1.amazonaws.com/turnstile/${this.shopId}`,
                { method: 'HEAD' }
            );
            return response.ok;
        } catch {
            return false;
        }
    }

    beforeDestroy() {
        if (window.turnstile && this.widgetId) {
            window.turnstile.remove(this.widgetId);
        }
    }
}
